import { PsObject } from "./core/PsObject";
import DefaultPhoto from "./DefaultPhoto";

export default class AcceptCartItem extends PsObject<AcceptCartItem>{

    id: string = '';
    catName: string  = ''
    subCatName: string  = ''
    price: string  = ''
    title: string  = ''
    itemLocationName: string  = ''
    ExchangeId: string  = ''
    itemLocationTownship_name: string  = ''
    defaultPhoto : DefaultPhoto = new DefaultPhoto();

    init(
        id: string,
        catName: string,
        subCatName: string,
        price: string,
        title: string,
        itemLocationName: string,
        ExchangeId: string,
        itemLocationTownship_name: string,
        defaultPhoto : DefaultPhoto,

    ) {
        this.id = id;
        this.catName = catName;
        this.subCatName =subCatName;
        this.price =price;
        this.title =title;
        this.itemLocationName =itemLocationName;
        this.ExchangeId = ExchangeId;
        this.itemLocationTownship_name =itemLocationTownship_name;
        this.defaultPhoto = defaultPhoto;
        
        return this;

    }

    getPrimaryKey(): string {
        return this.id;
    }

    toMap(object: AcceptCartItem): any {
        const map = {};
        map['id'] = object.id;
        map['cat_name'] = object.catName;
        map['sub_cat_name'] = object.subCatName;
        map['price'] = object.price;
        map['title'] = object.title;
        map['item_location_name'] = object.itemLocationName;
        map['exchange_id'] = object.ExchangeId;
        map['item_location_township_name'] = object.itemLocationTownship_name;
        map['default_image'] = new DefaultPhoto().toMap(object.defaultPhoto);

        return map;
    }

    toMapList(objectList: AcceptCartItem[]) : any[] {
        const mapList : any[] = [];
        for(let i = 0; i < objectList.length; i++) {
            if(objectList[i] != null) {
                mapList.push(this.toMap(objectList[i]));
            }
        }

        return mapList;
    }

    fromMap(obj: any) {
        return new AcceptCartItem().init(
          obj.id,
          obj.cat_name,
          obj.sub_cat_name,
          obj.price,
          obj.title,
          obj.item_location_name,
          obj.exchange_id,
          obj.item_location_township_name,
          obj.default_image,
       );
    }   
    fromMapList(objList : any[] ) : AcceptCartItem[] {
        const blueMarkUserList : AcceptCartItem[] = [];
        for(const obj in objList) {
            if(obj != null) {
                blueMarkUserList.push(this.fromMap(obj));
            }
        }

        return blueMarkUserList;
    }
    

}